<app-dialog
  [title]="'Feedback'"
  [actions]="[
  { text: 'Cancel', buttonStyle: 'underline' },
  { text: 'Submit', isDisabled:  !feedbackForm.valid },
]"
  (action)="close($event)"
  (close)="close()"
>
  <div class="feedback">
    <div class="input-container">
      <label for="" class="input-container"
        >We would love to hear from you! Please enter your feedback in the text
        area below.</label
      >
      <textarea
        [formControl]="feedbackForm"
        name=""
        id=""
        cols="30"
        rows="4"
        class="input-container_input"
      ></textarea>
    </div>
  </div>
</app-dialog>
